import { z } from 'zod'

export const medicalDeferralSchema = (t: (key: string) => string) =>
  z.object({
    deferral_end_date: z
      .string()
      .min(1, t('donor_detail.medical_history.deferral_modal.date_required')),
  })

export type MedicalDeferralFormValues = z.infer<
  ReturnType<typeof medicalDeferralSchema>
>
